import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { FileSharer } from '@byteowls/capacitor-filesharer';
import FileSave from 'custom-plugins/android/file-save';
import { ApiService } from 'src/app/services/api-services/api.service';

@Component({
  selector: 'app-event-description-modal',
  templateUrl: './event-description-modal.component.html',
  styleUrls: ['./event-description-modal.component.scss']
})
export class EventDescriptionModalComponent {
  @Input() calendarEvent: any;
  @Input() selectedContentSegment: string = 'text';
  @Input() title: string;
  attachmentsLoading: boolean = false;

  constructor(private modalController: ModalController, private apiService: ApiService) {}

  dismiss() {
    this.modalController.dismiss();
  }

  switchSegment(segment: string) {
    this.selectedContentSegment = segment;
  }

    async downloadAttachment(attachment: any) {
    this.attachmentsLoading = true;
    try {
      const platform = Capacitor.getPlatform();
      const fileName = attachment.name;
      
      this.apiService.getEventAttachmentFile(this.calendarEvent.id, attachment.id).subscribe({
        next: (blob: Blob) => {
          this.shareFile(blob, fileName, attachment.contentType);
        },
        error: (error) => {
        console.error('Error downloading attachment:', error);
        },
        complete: () => {
          this.attachmentsLoading = false;
        }
      });
    } catch (error) {
      console.error('Error downloading attachment:', error);
      this.attachmentsLoading = false;
    }
  }

  private async shareFile(blob: Blob, fileName: string, contentType: string) {
    try {
      const platform = Capacitor.getPlatform();
      
      // Convert blob to base64
      const reader = new FileReader();
      reader.onload = async () => {
        const base64Data = (reader.result as string).split(',')[1];
        
        if (platform === 'android') {
          // Use custom FileSave plugin for Android
          try {
            const result = await FileSave.saveFile({
              filename: fileName,
              mimeType: contentType,
              base64Data: base64Data,
            });
            
            if (result.uri) {
              console.log('File saved successfully at:', result.uri);
              // You can add a success toast here if needed
            }
          } catch (error) {
            console.error('Error saving file on Android:', error);
            // You can add an error toast here if needed
          }
        } else {
          // Use FileSharer for other platforms (iOS, web, etc.)
          try {
            await FileSharer.share({
              filename: fileName,
              contentType: contentType,
              base64Data: base64Data,
            });
          } catch (error) {
            console.error('Error sharing file:', error);
            // You can add an error toast here if needed
          }
        }
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error('Error sharing file on mobile:', error);
    }
  }
} 